<script>
import { Line } from 'vue-chartjs'
import {
  Chart, LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend
} from 'chart.js'

Chart.register(LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend)

export default {
  name: 'OrdersWeeklyChart',
  components: { Line },
  emits: ['select-date'],
  props: {
    labels: { type: Array, required: true },
    series: { type: Array, required: true } // [10,12,8, ...]
  },
  computed: {
    data () {
      return {
        labels: this.labels,
        datasets: [
          {
            label: '최근 7일 오더접수',
            data: this.series,
            fill: false,
            borderColor: '#1976d2',
            backgroundColor: '#1976d2',
            pointBackgroundColor: '#ffffff',
            pointBorderColor: '#1976d2',
            pointBorderWidth: 2,
            pointRadius: 4,
            pointHoverRadius: 6,
            tension: 0.25
          }
        ]
      }
    },
    options () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: true },
          tooltip: {
            callbacks: {
              title: (items) => this.formatDateLabel(items?.[0]?.label)
            }
          }
        },
        onClick: (_, elements) => {
          const index = elements?.[0]?.index
          if (Number.isInteger(index) && this.labels[index]) this.$emit('select-date', this.labels[index])
        },
        scales: {
          x: {
            ticks: {
              callback: (_, index) => this.formatDateLabel(this.labels[index])
            }
          },
          y: {
            beginAtZero: true,
            grace: '10%',
            ticks: {
              // Hide decimal tick labels
              callback: (value) => Number.isInteger(value) ? value : ''
            }
          }
        }
      }
    }
  },
  methods: {
    formatDateLabel (value) {
      const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '')
      if (!match) return value || ''

      const [, year, month, day] = match
      const weekday = ['일', '월', '화', '수', '목', '금', '토'][new Date(Number(year), Number(month) - 1, Number(day)).getDay()]
      return `${month}/${day}(${weekday})`
    }
  }
}
</script>

<template>
  <div style="height:300px">
    <Line :data="data" :options="options" />
  </div>
</template>
